/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiAnimationEasing {
	EASE, LINEAR, EASE_IN, EASE_OUT, EASE_IN_OUT, STEP_START, STEP_END
}